import React from 'react';
import axios from 'axios'
import PermIdentityIcon from '@mui/icons-material/PermIdentity';

import { url } from '../../weburl';

import CountryContext from '../../home/country_context';

export class PostProfile extends React.Component {
    static contextType = CountryContext
    constructor(props) {
        super(props)
        this.state = {
            posts: {},
            posts_loaded: false
        }
    }



    render() {
        return (
            <div className='container   text-left bg-white rounded box_shadow 
            d-none d-sm-block position-sticky animate__animated animate__fadeInLeft animate__slow'>
                <div className='row align-items-center justify-content-center'>
                    <div className='col-md-12 text-center'>
                        {
                            this.context && this.context.user_sql_details &&  this.context.user_sql_details.public_id ?
                                <img
                                    className='rounded-circle image_fluid'
                                    src={`https://res.cloudinary.com/daurieb51/image/upload/v1654329095/${this.context.user_sql_details.public_id}.jpg`}
                                    alt="" width={'50%'} />
                                :
                                // <img
                                //     className='rounded-circle image_fluid'
                                //     src={`https://res.cloudinary.com/daurieb51/image/upload/v1654329095/${this.context.user_sql_details.public_id}.jpg`}
                                //     alt="" width={'50%'} />

                                <PermIdentityIcon />
                        }

                    </div>
                </div>
                <div className='row align-items-start justify-content-start my-1'>
                    <div className='col-md-10 '>
                        <p className='text-dark'>Name: &nbsp;
                            <span className='posts-name'>
                                {this.context.user && this.context.user_sql_details && this.context.user_sql_details.username}

                            </span>                           </p>
                        <p className='text-dark'>Posts: <span>N/A</span></p>
                        <p className='text-dark'>Following: <span>N/A</span></p>
                        <p className='text-dark'>Followers: <span>N/A</span></p>
                        {/* <p className='text-dark'>Community Name: N/A</p> */}

                    </div>
                </div>
                <div className='row align-items-center justify-content-center'>
                    {/* <div className='col-md-12'>
                        <img src="https://res.cloudinary.com/daurieb51/image/upload/v1654705781/fatality_skullcandy_wvw6ei.jpg" alt="" width={'100%'} />
                    </div> */}
                </div>
            </div>
        )

    }


}
